import useQueryParams from './useQueryParams';

/**
 * Returns the value of the query param specified from the underlying URLSearchParams object.
 *
 * If you want to access multiple query params consider using the useQueryParams hook.
 */
export function useQueryParam<T extends string | null = string>(name: string, defaultValue: T): T;
export function useQueryParam<T extends string | null = string>(name: string, defaultValue?: T): T | undefined;
export function useQueryParam<T extends string | null = string>(name: string, defaultValue?: T): T | undefined {
  const queryParams = useQueryParams();

  return (queryParams.get(name) as T) ?? defaultValue;
}

export function useQueryParamAll<T extends string = string>(name: string): T[] {
  const queryParams = useQueryParams();

  return queryParams.getAll(name) as T[];
}
